export default "__VITE_ASSET__BHMdAnRe__"